import React, { useEffect, useState } from 'react';
import api from '../utils/axiosConfig';
import '../css/Inbox.css';

function Inbox() {
  const [messages, setMessages] = useState([]);
  const [selectedMessage, setSelectedMessage] = useState(null);

  const fetchMessages = async () => {
    try {
      const res = await api.get('/api/contact');
      setMessages(res.data);
    } catch (err) {
      console.error('Error fetching messages:', err);
    }
  };

  useEffect(() => {
    fetchMessages();
  }, []);

  const handleDelete = async (id) => {
    if (!window.confirm('Nachricht wirklich löschen?')) return;

    try {
      await api.delete(`/api/contact/${id}`);
      fetchMessages();
    } catch (err) {
      console.error('Delete error:', err);
    }
  };

  const handleMarkDone = async (id) => {
    try {
      await api.patch(`/api/contact/${id}/status`, {
        status: 'Erledigt'
      });
      fetchMessages();
    } catch (err) {
      console.error('Update error:', err);
    }
  };

  return (
    <div className="inbox-container">
      <h1>Nachrichten</h1>
      <div className="inbox-table-wrapper">
      <table className="inbox-table">
        <thead>
          <tr>
            <th>Name</th>
            <th>Email</th>
            <th>Telefon</th>
            <th>Status</th>
            <th>Datum</th>
            <th>Aktionen</th>
          </tr>
        </thead>

        <tbody>
          {messages.map((msg) => (
            <tr key={msg._id} className={msg.isRead ? '' : 'unread'}>
              <td>{msg.name}</td>
              <td>{msg.email}</td>
              <td>{msg.phone}</td>
              <td>{msg.status}</td>
              <td>{new Date(msg.createdAt).toLocaleString()}</td>

              <td>
                <button onClick={() => setSelectedMessage(msg)}>👁</button>
                <button onClick={() => handleMarkDone(msg._id)}>✔</button>
                <button onClick={() => handleDelete(msg._id)}>🗑</button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      </div>

      {/* VIEW MODAL */}
      {selectedMessage && (
        <div className="modal">
          <div className="modal-content">
            <h2>Nachricht</h2>
            <p><strong>Name:</strong> {selectedMessage.name}</p>
            <p><strong>Email:</strong> {selectedMessage.email}</p>
            <p><strong>Telefon:</strong> {selectedMessage.phone}</p>
            <p><strong>Nachricht:</strong></p>
            <p>{selectedMessage.message}</p>

            <button onClick={() => setSelectedMessage(null)}>Schließen</button>
          </div>
        </div>
      )}
    </div>
  );
}

export default Inbox;